import React, { useState } from "react";
import { ClearableCheckboxDropdown, Table, TimestampFilters } from "dyl-components";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Table as SemanticTable, Icon } from "semantic-ui-react";
import { getData, onToggleTimeUnit, useRangeCalendar } from "shared/CustomDateRange/customDateRange";

const SortActions = ({ direction = false, onToggleSort = () => { } }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};

const HistoryHeader = ({ onFilter }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const listViewUrl = '';

    const {
        timestamp,
        setTimestamp,
        isCustomDateRangeOpen,
        setCustomDateRangeOpen,
        userAuthTimezone,
        dateRange,
        setDateRange
    } = useRangeCalendar(params);

    const lastModifiedOrder = params.get("order") === "asc";

    const lastModifiedFilter = () => {
        const query = new URLSearchParams(params);
        const order = !lastModifiedOrder ? "asc" : "desc";
        query.set("order", order);
        const query_string = query.toString();
        navigate(`${query_string ? `?${query_string}` : ""}`);
    };

    const onDateRangeChange = (_, { value }) => {
        setDateRange(value);
    };
    const location = useLocation();

    const activityTypeOptions = [
        { key: "address", value: "address", text: "Address" },
        { key: "assignment", value: "assignment", text: "Assignment" },
        { key: "email", value: "email", text: "Email" },
        { key: "name", value: "name", text: "Name" },
        { key: "phone_number", value: "phone_number", text: "Phone Number" },
        { key: "record", value: "record", text: "Record" },
        { key: "route", value: "route", text: "Route" },
        { key: "website", value: "website", text: "Website" },
        { key: "bulk_action", value: "bulk_action", text: "Bulk Action" },
        ...(location.pathname?.includes("contact")
            ? [{ key: "sequence", value: "sequence", text: "Sequence" }]
            : [])
    ];

    const [isTimeRangeOpen, setTimeRangeOpen] = useState(false);

    return (
        <Table.Row>
            <SemanticTable.HeaderCell width={3}>
                <span style={{ marginRight: 10 }}>Created</span>
                <TimestampFilters
                    timestamp={timestamp}
                    onToggleTimeUnit={(timestamp) =>
                        onToggleTimeUnit(
                            timestamp,
                            setTimestamp,
                            params,
                            navigate,
                            listViewUrl
                        )
                    }
                    areTimeUnitOptionsOpen={isTimeRangeOpen}
                    onOpenTimeUnitOptions={() => setTimeRangeOpen(true)}
                    onCloseTimeUnitOptions={() => setTimeRangeOpen(false)}
                    isCustomDateRangeOpen={isCustomDateRangeOpen}
                    onOpenCustomDateRange={() => {
                        setCustomDateRangeOpen(true);
                        setDateRange('');
                    }}
                    onCloseCustomDateRange={() => {
                        setCustomDateRangeOpen(false);
                    }}
                    dateRange={dateRange}
                    onDateRangeChange={onDateRangeChange}
                    getData={() =>
                        getData({
                            setCustomDateRangeOpen,
                            dateRange,
                            userAuthTimezone,
                            params,
                            navigate,
                            url: listViewUrl
                        })
                    }
                />
                <SortActions
                    direction={lastModifiedOrder}
                    onToggleSort={lastModifiedFilter}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                <ClearableCheckboxDropdown
                    text="Activity Type"
                    name="activity_type"
                    options={activityTypeOptions}
                    onChange={(_, { value }) => {
                        onFilter(_, { name: "activity_type", value });
                    }}
                    value={params.get("activity_type")?.split(",")}
                    closeOnLoad={true}
                />
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={6}>
                Message/Note
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                Contact/Account
            </SemanticTable.HeaderCell>
            <SemanticTable.HeaderCell width={3}>
                User
            </SemanticTable.HeaderCell>
        </Table.Row>
    )
}

export default HistoryHeader;
